import { useForm } from 'react-hook-form';

const defaultValues = {
  company_type: '0',
  account_cash_only: false,
  company_number: '',
  company_name: '',
  company_vat_number: '',
  customer: {
    business_type: '',
    title: '',
    forename: '',
    surname: '',
    email: '',
    telephone: '',
  },
  addresses: {
    1: {
      house_number: '',
      address_line_1: '',
      address_line_2: '',
      address_line_3: '',
      address_line_4: '',
      postcode: '',
      own: null,
      more_than_3_years: null,
    },
    2: {
      house_number: '',
      address_line_1: '',
      address_line_2: '',
      address_line_3: '',
      address_line_4: '',
      postcode: '',
    },
  },
  account_contact_name: '',
  account_contact_email: '',
  account_contact_telephone: '',
  purchasing_contact_name: '',
  purchasing_contact_email: '',
  purchasing_contact_telephone: '',
  date_of_birth: {
    day: '',
    month: '',
    year: '',
  },

  // VALIDATION FIELDS ONLY - NO DATA SENT
  companyNumberSearched: false,
  companyNumberLookupSuccess: false,
  billingAddressMatchesRegistered: true,

  // Manual Company Address Postcode Selector
  manualCompanySearchPostcodeValid: false,
  manualCompanyAddressSelectorValid: false,
  manualCompanyLine1Valid: false,
  manualCompanyPostcodeValid: false,

  // Billing Address Postcode Selector
  billingSearchPostcodeValid: false,
  billingAddressSelectorValid: false,
  billingLine1Valid: false,
  billingPostcodeValid: false,

  // Home Address Postcode Selector
  homeSearchPostcodeValid: false,
  homeAddressSelectorValid: false,
  homeLine1Valid: false,
  homePostcodeValid: false,
  homeLine4Valid: false,
  homeNumberValid: false,

  // Previous Address Postcode Selector
  previousSearchPostcodeValid: false,
  previousAddressSelectorValid: false,
  previousLine1Valid: false,
  previousPostcodeValid: false,

  // DOB Verification
  dateOfBirthEntered: false,
};

const useFormConfig = () => {
  const {
    control,
    trigger,
    watch,
    setValue,
    handleSubmit,
    formState,
    setError,
    clearErrors,
    reset,
  } = useForm({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues,
  });

  return {
    control,
    trigger,
    watch,
    setValue,
    handleSubmit,
    formState,
    setError,
    clearErrors,
    reset,
  };
};

export default useFormConfig;
